/**
 * Step timeline label formatting for the read-only Work card panel (spec
 * #192, correcting #177's own "briefing received / accepted / opened /
 * uploading / delivered / revision requested / revision delivered"
 * vocabulary). The card timeline now shows the SAME five phases the board
 * columns use - `PHASE_LABELS` (`./phases.ts`) is the one label source,
 * never a second copy here. The only thing this module adds is the revision
 * round suffix, which is purely a rendering decision over the `round` the
 * server already attaches to an `in_revision`/`delivered` step.
 *
 * @module web/screens/app/board/steps
 */
import type { WorkPhaseStep } from "../../../api/types.ts";
import { PHASE_LABELS } from "./phases.ts";

/** "In revision (round 2)" / "Delivered (revision 2)" / plain `PHASE_LABELS[step.phase]` otherwise. */
export function stepLabel(step: WorkPhaseStep): string {
  const base = PHASE_LABELS[step.phase];
  if (step.round == null) return base;
  return step.phase === "in_revision" ? `${base} (round ${step.round})` : `${base} (revision ${step.round})`;
}
